module.exports = __webpack_public_path__ + "img/palatine_b1.88e0f04b.jpg";